<div class="slide" [ngClass]="indice===1 ? 'un' : indice === 2 ? 'deux' : 'trois'">
    <picture>
        <source
            media="(max-width: 900px)"
            type="image/webp"
            [attr.srcset]="'/assets/webp/slide'+indice+'petit.webp'"
        />
        <source
            media="(min-width: 901px) and (max-width: 2000px)"
            type="image/webp"
            [attr.srcset]="'/assets/webp/slide'+indice+'moyen.webp'"
        />
        <source
            media="(min-width: 2001px)"
            type="image/webp"
            [attr.srcset]="'/assets/webp/slide'+indice+'.webp'"
        />
        <img 
            style="position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; z-index: 0;"
            fetchpriority="high"
            loading="eager"
            decoding="async"
            alt="image de bannière d'accueil de MACE maison d'assurance du centre Est"
            [src]="'/assets/slide'+indice+'.png'"
        />
    </picture>


    <div class="ht">
        <div class="fleche">
            <picture>
                <source
                    type="image/webp"
                    srcset="assets/webp/gauche.webp"
                    alt="fleche-g">

                <img *ngIf="indice>1" (click)="indice = indice-1;"src="./../../../assets/gauche.png" alt="fleche-g">
            </picture>
        </div>
        <div class="main">
            <div class="titre" *ngIf="indice===1">
                <div class="premier">MACE ASSURANCES</div>
                <div class="mots3">ENTREPRISES - PROFESSIONNELS - PARTICULIERS</div>
                <div class="second">Courtier en Assurance</div>
            </div>
            <div class="titre" *ngIf="indice===2" >
                <div class="premier">Spécialistes de l'Assurance</div>
                <div class="mots3">ENTREPRISES - PROFESSIONNELS - PARTICULIERS</div>
                <div class="second">Auto - Habitation - Santé - Professionnelle - Accidents de la vie - Prêt</div>
            </div>
            <div class="titre" *ngIf="indice===3">
                <div class="premier">S'assurer en toute sécurité avec MACE ASSURANCES</div>
                <div class="mots3">ENTREPRISES - PROFESSIONNELS - PARTICULIERS</div>
                <div class="second">Nous vous accompagnons dans vos démarches professionnelles et particulières</div>
            </div>
        </div>
        <div class="fleche">
            <picture>
                <source
                    type="image/webp"
                    srcset="assets/webp/droite.webp"
                    alt="fleche-d">
                <!--fallback-->
                <img *ngIf="indice<3" (click)="indice=indice+1;"src="./../../../assets/droite.png" alt="fleche-d">
            </picture>
        </div>
    </div>

    <div class="bas">
            <div [ngClass]="indice===1?'point select':'point'" (click)="indice=1;"></div>
            <div [ngClass]="indice===2?'point select':'point'"(click)="indice=2;"></div>
            <div [ngClass]="indice===3?'point select':'point'"(click)="indice=3;"></div>
    </div>
</div>
